<form class="flex flex-col gap-5" [formGroup]="form">
  <div>
    <div class="font-semibold">
      <div>{{ 'two-factor-auth-page.app.used-email' | translate }}</div>
    </div>
    <div class="pt-2">{{ authCommunication() }}</div>
  </div>

  @if (typeOfAuthentication() === 'sms') {
    <div class="mt-5">
      <span class="hover:cursor-text">
        {{ 'two-factor-auth-page.sms.activation-code.send-to' | translate }}
        @if (retryInSeconds() === 0) {
          <span class="text-xs text-primary-100 underline hover:cursor-pointer hover:text-primary-130" (click)="sendSmsAgain()">
            {{ 'two-factor-auth-page.sms.activation-code.send-again' | translate }}
          </span>
        } @else {
          <span class="text-xs text-neutral-60 underline">
            {{ 'two-factor-auth-page.sms.activation-code.retry' | translate: { RetryInSeconds: retryInSeconds() } }}
          </span>
        }
      </span>
    </div>
  }
  <div class="pt-3 text-sm">
    @if (typeOfAuthentication() === 'sms') {
      {{ 'two-factor-auth-page.pin-entry-description' | translate }}
    } @else {
      {{ 'setup-two-factor-auth-app.code.extra-text' | translate }}
    }
  </div>
  <span class="-mb-2 font-semibold">
    {{ 'two-factor-auth-page.pin-entry.label' | translate }}
    <span class="text-negative-100">*</span>
  </span>
  <pay-lib-pin-entry #pinEntryComponent (pressedEnter)="submit()" [pinCount]="typeOfAuthentication() === 'sms' ? 5 : 6" />
  <div class="flex flex-col gap-3">
    <span class="flex flex-row items-center gap-1 font-semibold">
      {{ 'common.remember-me' | translate }}
      <svg class="size-4 cursor-pointer" viewBox="0 0 32 32" (click)="openRememberMeInfo()">
        <polygon points="17 22 17 14 13 14 13 16 15 16 15 22 12 22 12 24 20 24 20 22 17 22" />
        <path d="M16,8a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,16,8Z" />
        <path d="M16,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30ZM16,4A12,12,0,1,0,28,16,12,12,0,0,0,16,4Z" />
      </svg>
    </span>
    <ng-form
      class="grid w-full max-w-[500px] grid-cols-2 gap-2 sm:flex sm:flex-row sm:justify-evenly [&>*:last-child:nth-child(odd)]:col-span-2"
      [formGroup]="form">
      @for (option of REMEMBER_ME_VALUES; track option) {
        <div
          (click)="selectOption(option)"
          class="flex min-w-0 cursor-pointer select-none gap-1 rounded-xl border border-neutral-40 bg-neutral p-2 px-3 text-center text-neutral-40 has-[:checked]:border-primary-100 has-[:checked]:bg-secondary-10 has-[:checked]:text-primary-100 sm:px-4">
          <input type="radio" class="hidden cursor-pointer" id="{{ option }}" name="rememberMe" [formControl]="form.controls.remember" value="{{ option }}" />
          <label class="lufga text-sd w-full cursor-pointer truncate" for="{{ option }}">{{ 'rememberMe.' + option?.replace(' ', '') | translate }}</label>
        </div>
      }
    </ng-form>
  </div>
  <div class="mt-8 flex flex-col gap-6">
    @if (error(); as e) {
      <pay-login-error-badge [error]="e" />
    }

    <pay-button-primary (click)="submit()" [loading]="isSubmitting()" [disabled]="form.invalid && form.touched" [rounded]="'rounded-lg'">
      {{ 'authentication-setup-button.confirm' | translate }}
    </pay-button-primary>
    <div class="self-center">
      <span class="text-primary-100 underline hover:cursor-pointer hover:text-primary-130" (click)="returnToLogin()">
        {{ 'authentication-setup-page.go-back' | translate }}
      </span>
    </div>
  </div>
</form>
